module.exports = __webpack_public_path__ + "img/terroir-inspect-large.afc9db75.jpg";